export default "__VITE_ASSET__ZhXQhwo___"